import { render, staticRenderFns } from "./QuickFunctions.vue?vue&type=template&id=4b7d8c0a&scoped=true"
import script from "./QuickFunctions.vue?vue&type=script&lang=js"
export * from "./QuickFunctions.vue?vue&type=script&lang=js"
import style0 from "./QuickFunctions.vue?vue&type=style&index=0&id=4b7d8c0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d8c0a",
  null
  
)

export default component.exports